import { createFileRoute } from "@tanstack/react-router";
import { AuditTrailPage } from "../components/audit/AuditTrailPage";
import { ToWorkspaces } from "../components/workspaces/ToWorkspaces";
import { ApiError } from "../lib/api";
import { workspaceSlug } from "../lib/hosts";
import { useWorkspace } from "../lib/workspaces";
import { AdministratorsOnly } from "../components/ui/states";
import { strings } from "../lib/strings";

/** Settings › Audit trail (BUILD_SPEC §25), for the workspace's Administrators. */
function AuditRoute() {
  const view = useWorkspace(workspaceSlug());
  if (view.isLoading) return null;
  if (view.error instanceof ApiError || !view.data) return <ToWorkspaces />;
  if (view.data.role !== "administrator") return <AdministratorsOnly what={strings.states.adminPages.audit} />;
  return <AuditTrailPage />;
}

export const Route = createFileRoute("/admin/settings/audit")({ component: AuditRoute });
